export const RTL_LOCALE_CODES = ['ar-AE', 'he'];
